export default {"src":"/_next/static/media/go.c93ed780.svg","height":192,"width":512,"blurWidth":0,"blurHeight":0};